/// <reference types="vite-plugin-svgr/client" />
/// <reference types="vite/client" />
import 'draft-js/dist/Draft.css';
import Radium from 'radium';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import type { Store } from 'redux';

import ThirdPartyScripts from 'components/Common/ThirdPartyScripts';

import './index.css';
import './scripts/initSegment';
import './scripts/initSegmentV2';
import './scripts/thirdPartyScripts';

const { StyleRoot } = Radium;

const startRevenueBrowserMswIfEnabled = async () => {
  if (
    !import.meta.env.DEV ||
    import.meta.env.VITE_REVENUE_MSW_ENABLED !== 'true'
  ) {
    return;
  }

  const { startRevenueBrowserMsw } = await import(
    './__tests__/regression/revenue/msw/browser'
  );

  await startRevenueBrowserMsw();
};

const renderApp = async () => {
  await startRevenueBrowserMswIfEnabled();

  const App = (await import('./components/App')).default;
  const reduxStore = (await import('./helpers/reduxStore')).default as Store;

  const rootElement = document.getElementById('root');

  if (!rootElement) {
    throw new Error('Unable to find the Avoma app root element.');
  }

  ReactDOM.render(
    <Provider store={reduxStore}>
      <StyleRoot style={{ height: '100%' }}>
        <ThirdPartyScripts />
        <App />
      </StyleRoot>
    </Provider>,
    rootElement
  );
};

renderApp();
